import { styled } from '@mui/material';
import { globalZindex } from 'core/common/constants';
import Icon from 'core/svg-sprites/ui/Icon';

export const SupportBotWrapperStyled = styled('div')<{ variant: 'static' | 'fixed' }>`
  position: ${({ variant }) => (variant === 'fixed' ? 'fixed' : 'static')};
  right: 15px;
  bottom: 16px;
  z-index: ${globalZindex.banner};

  @media ${(props) => props.theme.breakpoints.desktop} {
    right: 100px;
    bottom: 20px;
  }
`;

export const IconStyled = styled(Icon)`
  margin-right: 4px;
  fill: currentColor;
`;
